/**
 * Whether AnnotationsProvider should apply a selectionchange update.
 *
 * selectionchange fires very frequently; rewriting identical range text causes
 * needless React updates around the highlight tooltip.
 *
 * @param options.previousText - Last applied range text (null when cleared)
 * @param options.nextText - Incoming range text (null means clear selection)
 * @returns True when state should change
 */
export const shouldUpdateAnnotationRange = (options: {
	previousText: string | null;
	nextText: string | null;
}): boolean => {
	return options.previousText !== options.nextText;
};
